import React from 'react';
import Abdullah from '../assets/images/testimonial/Abdullateef Abdullahi Isah.jpeg';
import Abdulrahman from '../assets/images/testimonial/Abdulrahman Ibrahim Itas.jpeg';
import Asmua from '../assets/images/testimonial/Asmau Balarabe Alti.jpeg';
import Hallem from '../assets/images/testimonial/Haleemah Ameeru Tukur.jpeg';
import Maryam from '../assets/images/testimonial/Maryam Ibrahim.jpeg';
import Ukasha from '../assets/images/testimonial/Ukasha Ahmad.jpeg';
import yusuf from '../assets/images/testimonial/Aweda Yusuf.jpeg';

function Testimonial() {
  return (
    <div
      id='carouselExampleCaptions'
      className='carousel slide relative carousel-dark my-[40px]'
      data-bs-ride='carousel'
    >
      <div className='carousel-inner relative w-full overflow-hidden'>
        <div className='carousel-item active relative float-left w-full text-center'>
          <p className='text-xl italic mx-auto text-gray-700 max-w-4xl'>
            "Wootlab is indeed a blessing for the less privileged class. I will
            keep telling our friends about Wootlab and what they did and their
            ambitions towards digitalising the youth to make their generation
            self-reliant."
          </p>
          <div className='mt-12 mb-6 flex justify-center'>
            <img
              src={Abdullah}
              className='rounded-full w-24 h-24 shadow-lg'
              alt='photo missing'
            />
          </div>
          <p className='text-gray-500'>- Abdullateef Abdullahi</p>
        </div>
        <div className='carousel-item relative float-left w-full text-center'>
          <p className='text-xl italic mx-auto text-gray-700 max-w-4xl'>
            "I am a student at Jigawa State College of Education. I came across
            Wootlab Foundation on social media. I have learned so many things
            such as the use of Excel, PowerPoint, Microsoft Office, Canva, Corel
            Draw. I really want to thank Wootlab foundation for their guidance
            in making me digitally equipped for today's job market. "
          </p>
          <div className='mt-12 mb-6 flex justify-center'>
            <img
              src={Ukasha}
              className='rounded-full w-24 h-24 shadow-lg'
              alt='photo missing'
            />
          </div>
          <p className='text-gray-500'>- Ukasha Ahmad</p>
        </div>
        <div className='carousel-item relative float-left w-full text-center'>
          <p className='text-xl italic mx-auto text-gray-700 max-w-4xl'>
            "I have no words to thank Wootlab foundation for their countless
            support to multiple people across the country and I happened to be
            one of them. My journey with Wootlab has been so amazing and
            beautiful indeed. I want to thank Wootlab foundation for granting me
            this outstanding opportunity to learn how to build and increase my
            sources."
          </p>
          <div className='mt-12 mb-6 flex justify-center'>
            <img
              src={Abdulrahman}
              className='rounded-full w-24 h-24 shadow-lg'
              alt='photo missing'
            />
          </div>
          <p className='text-gray-500'>- Abdulrahman Ibrahim</p>
        </div>
        <div className='carousel-item relative float-left w-full text-center'>
          <p className='text-xl italic mx-auto text-gray-700 max-w-4xl'>
            " The Wootlab graphics design scholarship has been outstanding, with
            the instructor being very detailed and understandable. I can now
            confidently make fliers and even a logo for my business and other
            endeavours I recently secured a job as an Office Assistant and the
            courses at Wootlab have been immensely helpful, from Microsoft
            Office 365 to Word, etc. I look forward to a more beautiful
            experience in my tech journey."
          </p>
          <div className='mt-12 mb-6 flex justify-center'>
            <img
              src={Asmua}
              className='rounded-full w-24 h-24 shadow-lg'
              alt='photo missing'
            />
          </div>
          <p className='text-gray-500'>- Asmau Balarabe</p>
        </div>
        {/* <div className='carousel-item relative float-left w-full text-center'>
          <p className='text-xl italic mx-auto text-gray-700 max-w-4xl'>
            "Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur est laborum neque cupiditate
            assumenda in maiores."
          </p>
          <div className='mt-12 mb-6 flex justify-center'>
            <img
              src={Hallem}
              className='rounded-full w-24 h-24 shadow-lg'
              alt='photo missing'
            />
          </div>
          <p className='text-gray-500'>- Haleemah Ameeru</p>
        </div> */}
        <div className='carousel-item relative float-left w-full text-center'>
          <p className='text-xl italic mx-auto text-gray-700 max-w-4xl'>
            " I came across Wootlab Foundation on social media platforms where I
            got to know there's ongoing free training for graphics design that's
            about to start, After starting the course for some days I realized
            that I was in the right place as a designer, in a short while I
            learned how to use Corel draw and canva to create unique designs,
            which has really helped in moving my career forward. A big
            appreciation to Wootlab Foundation."
          </p>
          <div className='mt-12 mb-6 flex justify-center'>
            <img
              src={Maryam}
              className='rounded-full w-24 h-24 shadow-lg'
              alt='photo missing'
            />
          </div>
          <p className='text-gray-500'>- Maryam Ibrahim</p>
        </div>
        <div className='carousel-item relative float-left w-full text-center'>
          <p className='text-xl italic mx-auto text-gray-700 max-w-4xl'>
            "Coming across Wootlab LEADs Initiative where they offer free
            courses on digital marketing, graphics design and web design, I felt
            so excited because these are the top-notch digital skills needed to
            triumph in the 21st century. The course I took improved my skills in
            using photo editing and painting programs. My sincerest appreciation
            to Wootlab Foundation."
          </p>
          <div className='mt-12 mb-6 flex justify-center'>
            <img
              src={yusuf}
              className='rounded-full w-24 h-24 shadow-lg'
              alt='photo missing'
            />
          </div>
          <p className='text-gray-500'>- Aweda Yusuf</p>
        </div>
      </div>
      <button
        className='carousel-control-prev absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline left-0'
        type='button'
        data-bs-target='#carouselExampleCaptions'
        data-bs-slide='prev'
      >
        <span
          className='carousel-control-prev-icon inline-block bg-no-repeat'
          aria-hidden='true'
        ></span>
        <span className='visually-hidden'>Previous</span>
      </button>
      <button
        className='carousel-control-next absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline right-0'
        type='button'
        data-bs-target='#carouselExampleCaptions'
        data-bs-slide='next'
      >
        <span
          className='carousel-control-next-icon inline-block bg-no-repeat'
          aria-hidden='true'
        ></span>
        <span className='visually-hidden'>Next</span>
      </button>
    </div>
  );
}

export default Testimonial;
